import { render } from "./FranchiseHero.vue?vue&type=template&id=49e8bbde&scoped=true&ts=true"
import script from "./FranchiseHero.vue?vue&type=script&lang=ts"
export * from "./FranchiseHero.vue?vue&type=script&lang=ts"

import "./FranchiseHero.vue?vue&type=style&index=0&id=49e8bbde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e8bbde"]])

export default __exports__